import css from 'styled-jsx/css';

export const staticStyles = css.global`
  .PaymentsInfoConfirmationForm {
    &__actions {
      display: flex;
      justify-content: space-between;
    }
  }
`;
